import React from "react"
import * as url from "../../helpers/url_helper"

const menu = [
    {
        name: "Dashboard",
        href: "/dashboard",
        contextUri: "",
        actionType: "get",
        icon: <i className="bx bx-bar-chart"></i>,
        menuGroup: null
    },
    {
        name: "Users",
        href: "/users",
        contextUri: url.GET_USERS,
        actionType: "get",
        icon: <i className="bx bx-user"></i>,
        menuGroup: null
    },
    {
        name: "Brands",
        href: "/brands",
        contextUri: url.GET_BRANDS,
        actionType: "get",
        icon: <i className="bx bx-shield"></i>,
        menuGroup: null
    },
    {
        name: "Merchant Groups",
        href: "/merchant-groups",
        contextUri: url.GET_MERCHANT_GROUP,
        actionType: "get",
        icon: <i className='bx  bx-briefcase-alt'  ></i>,
        menuGroup: null
    },
    {
        name: "Merchants",
        href: "/merchants",
        contextUri: url.GET_MERCHANTS,
        actionType: "get",
        icon: <i className="bx bx-store"></i>,
        menuGroup: null
    },
    {
        name: "Curator Offers",
        href: "/curator-offers",
        contextUri: url.GET_CURATOR_OFFERS,
        actionType: "get",
        icon: <i className="bx bxs-offer"></i>,
        menuGroup: null
    },
    {
        name: "Operation Offers",
        href: "/operation-offers",
        contextUri: url.GET_OPERATION_OFFERS,
        actionType: "get",
        icon: <i className="bx bxs-offer"></i>,
        menuGroup: null
    },
    {
        name: "Approver Offers",
        href: "/approver-offers",
        contextUri: url.GET_APPROVER_OFFERS,
        actionType: "get",
        icon: <i className="bx bxs-offer"></i>,
        menuGroup: null
    },

    {
        name: "Published Offers",
        href: "/published-offers",
        contextUri: url.GET_PUBLISHED_OFFERS,
        actionType: "get",
        icon: <i className="bx bxs-offer"></i>,
        menuGroup: null
    },

]

export default menu
